module.exports = __webpack_public_path__ + "img/credits-oops.6eab9e42.png";